import React from 'react'

function CommunityAgreementES() {
  return (
    <>
      <p className="heading-1">
        Contrato de cesión de derechos sobre el Contenido creado por el Creator
      </p>

      <div className="paragraph-2">
        <p>
          Skeepers es una empresa por acciones simplificada, con un capital de
          11 470 723 euros, inscrita en el registro mercantil y de empresas de
          Marsella con el número 879 038 990, cuya sede social está ubicada en
          18-20 Avenue Robert Schuman, CS 40494, 13002 Marsella.
        </p>
        <p>
          En el presente contrato, el término «Skeepers» se refiere a Skeepers y
          sus filiales. Todos los términos que empiezan con mayúscula están
          definidos en las CGU de Skeepers.
        </p>
        <p>
          Al publicar contenido en el Sitio web, usted reconoce y acepta
          expresamente ceder a Skeepers, en las condiciones definidas a
          continuación, la totalidad de los derechos que usted tiene sobre el
          Contenido que ha creado (de acuerdo con las CGU de Skeepers, el
          término «Contenido» se refiere a los textos, imágenes, fotografías,
          dibujos, avatares y, de manera más general, toda publicación visual,
          textual, sonora o gráfica del Creator, en representación de los
          Productos, difundidos en el marco de los servicios), y autoriza
          expresamente a Skeepers a utilizar su imagen en las condiciones que se
          especifican a continuación:
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          1. Cesión de los derechos sobre el Contenido
        </p>
        <p>
          Como contrapartida a la propiedad del Producto recibido, usted cede
          expresamente y a título no exclusivo a Skeepers la totalidad de los
          derechos que usted posea sobre el Contenido, lo cual incluye el
          derecho para Skeepers:
        </p>
        <ul className="paragraph-2">
          <li>
            a utilizar, reproducir, sublicenciar, ceder, distribuir, fijar
            temporalmente o no, a difundir, poner en circulación, extraer,
            descargar, almacenar, catalogar, clasificar en una base de datos,
            hacer público, representar, y explotar el Contenido en todos los
            formatos y en todos los soportes conocidos y desconocidos a día de
            hoy y especialmente sin que esta lista revista un carácter
            limitativo, en internet independientemente del sufijo genérico,
            geográfico o de la extensión del nombre del dominio del sitio de
            internet que corresponde y del país receptor del Contenido (sobre
            todo en la plataforma y en el sitio de Skeepers, en redes sociales
            como Facebook, Twitter, Instagram, IGTV, Snapchat, en los sitios de
            distribución de contenidos audiovisuales como YouTube, Dailymotion,
            Pinterest, sino que además en Weibo, WeChat, y, de forma general, en
            cualquier otro soporte existente o venidero), en cualquier otra
            forma de difusión como el cine, la televisión terrestre, por
            satélite, por operadores de cable, por la TDT y por cualquier
            procedimiento existente o venidero, en Francia y en el extranjero;
          </li>
          <li>
            a hacer cualquier modificación en el Contenido, total o parcial,
            añadiendo, suprimiendo, adaptando, traduciendo, declinando, montando
            y doblando en un idioma distinto del francés, a extraer todo o parte
            del Contenido para todo el mundo y sobre cualquier modo de
            explotación apropiado y sobre cualquier soporte. Los Contenidos
            objeto de la cesión podrán, asimismo, estar sujetos a su adaptación
            o a su traducción, con el objeto de permitir su integración en el
            marco de otra obra audiovisual, multimedia o numérica, y en todos
            los soportes que se definen a continuación;
          </li>
          <li>
            a ceder todo o parte de los derechos que usted le ceda en los
            términos del presente contrato. Específicamente, podrá concederse el
            derecho de representación y difusión de su Contenido, a través de
            una sublicencia, en todos los soportes y en todos los formatos y,
            especialmente:
            <ul className="paragraph-2">
              <li>
                en Internet (particularmente en el sitio web o en las redes
                sociales de su Cliente como Facebook, Twitter, Instagram, IGTV,
                Snapchat, en los sitios de distribución de contenidos
                audiovisuales como YouTube, Dailymotion, Pinterest, así como en
                Weibo, WeChat y, de forma general, en cualquier otro soporte
                existente o venidero), en cualquier medio de difusión como el
                cine, la televisión terrestre, por satélite, por cable, TDT, y
                por cualquier procedimiento existente o venidero, en Francia y
                en el extranjero, en los sitios web de comercio electrónico en
                los cuales el Cliente ponga sus productos a la venta, sea él
                mismo o no el editor del sitio web de comercio electrónico)
                independientemente de que tengan sufijo genérico, geográfico o
                de la extensión del nombre del dominio del sitio de internet del
                Cliente y del país de recepción del Contenido;
              </li>
              <li>
                en lugares públicos de venta (comercios, puntos de venta) del
                Cliente, en ferias, salones, lugares físicos publicitarios,
                exposiciones y cualesquiera otras manifestaciones públicas donde
                el Cliente esté presente o esté representado;
              </li>
              <li>
                internamente a beneficio de los miembros y asalariados del
                Cliente.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          Esta cesión permite a Skeepers explotar dichos Contenidos, tanto con
          propósitos de comunicación externa como interna, ya sea a título
          gratuito, promocional, publicitario, en eventos, comercial y
          lucrativo, especialmente a través de la comercialización o la puesta a
          disposición de sus Clientes, directamente o por intermediación de
          terceros autorizados por Skeepers, de productos o servicios.
        </p>
        <p>
          La presente cesión de derechos se concede a partir del día en que
          acepte el presente contrato y durante el periodo legal de protección
          de los derechos. La presente cesión está autorizada en todo el mundo.
        </p>
        <p>
          En lo que concierne a sus derechos morales, el derecho de adaptación
          de los Contenidos permitirá a la empresa Skeepers introducir
          modificaciones en los Contenidos, tales como cualquier modificación
          que se considere necesaria debido a exigencias técnicas o para
          permitir la implementación de los Contenidos bajo cualquier formato y
          sobre cualquier soporte elegido por la empresa Skeepers sobre el cual
          se vayan a reproducir o representar los Contenidos. Usted tendrá
          prohibido oponerse o impugnar los cambios, pero igualmente podrá
          reclamar una compensación o remuneración de alguna cantidad por esos
          cambios porque la integridad de su trabajo es respetada en la medida
          de lo posible.
        </p>
        <p>
          Usted declara y garantiza a Skeepers ser titular exclusivo del
          conjunto de los derechos cedidos sobre el Contenido en virtud del
          presente contrato. Por tanto, usted garantiza haber obtenido, por
          parte de los autores posibles o sus asistentes que han sido
          introducidos en el marco de la realización de los Contenidos y puedan
          ser beneficiarios de los derechos cualesquiera que estos sean y
          hacerlos valer sobre los contenidos, todos los derechos y
          autorizaciones necesarias para ceder los derechos de propiedad
          asociados a los Contenidos a beneficio de Skeepers, y, especialmente,
          los derechos para utilizar la música adjunta a sus Contenidos si es
          necesario.
        </p>
        <p>
          Asimismo, usted declara que los derechos no han sido objeto de ninguna
          transferencia parcial o total, a título gratuito u oneroso, de ninguna
          licencia de explotación del tipo que sea, de ningún aval, ni de ningún
          derecho de garantía a nadie, ni de ninguna impugnación de la forma que
          sea, a excepción de la licencia otorgada a la red social en la cual
          usted ha publicado el Contenido.
        </p>
        <p>
          Usted garantiza el disfrute tranquilo de estos derechos y se
          compromete a indemnizar a Skeepers por todas las consecuencias,
          especialmente las económicas, que puedan resultar de toda oposición o
          reclamación que pueda promover un tercero relativa a la titularidad de
          los derechos sobre el Contenido.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Derechos de imagen</p>
        <p>
          En la medida en la que usted aparezca en el Contenido, autoriza
          expresamente a Skeepers a utilizar los atributos de su personalidad
          (especialmente la imagen, marca personal, logotipo, nombre, apellido y
          voz) con el objeto de permitir a Skeepers ejercer los derechos que le
          son permitidos sobre el Contenido de conformidad con el punto 1
          anterior.
        </p>
        <p>
          Como contrapartida de la propiedad del Producto recibido, autoriza
          expresamente a Skeepers:
        </p>
        <ul className="paragraph-2">
          <li>
            a captar, publicar, reproducir, adaptar e difundir su imagen
            (incluyendo especialmente su imagen, marca personal, logotipo, voz,
            nombre y apellido) en la totalidad de los soportes de publicación,
            reproducción y difusión mencionados en el punto 1) anterior, y
            especialmente en internet, en la plataforma y el sitio de Skeepers,
            en redes sociales como Facebook, Twitter, Instagram, IGTV, Snapchat,
            en los sitios de distribución de contenidos audiovisuales como
            YouTube Dailymotion, Pinterest, y además en Weibo, WeChat, y, de
            forma general, en cualquier otro soporte existente o venidero), por
            cualquier medio de difusión como el cine, la televisión terrestre,
            por satélite, por cable, por la TDT y por cualquier otro
            procedimiento existente o venidero, en Francia y en el extranjero,
            independientemente del sufijo genérico, geográfico o de la extensión
            del nombre del dominio del sitio de Internet afectado y del país de
            recepción del Contenido;
          </li>
          <li>
            a ceder a sus beneficiarios (especialmente los fabricantes,
            distribuidores, sitios de internet vendedores y más generalmente,
            sus clientes profesionales, etc.) el derecho bajo licencia a
            utilizar los atributos de su personalidad (especialmente la imagen,
            marca personal, logotipo, nombre, apellido y voz) en internet
            (especialmente en el sitio de internet o las redes sociales como
            Facebook, Twitter, Instagram, IGTV, Snapchat, en los sitios de
            distribución de contenidos audiovisuales como YouTube, Dailymotion,
            Pinterest, así como en Weibo, WeChat, y, de forma general, en
            cualquier otro soporte existente o venidero), en cualquier medio de
            difusión como el cine, la televisión terrestre, por satélite, por
            cable, la TDT, y cualquier otro procedimiento existente o venidero,
            en Francia y en el extranjero, en el sitio (os) de comercio
            electrónico en el cual el Cliente ponga sus productos a la venta, ya
            sea o no el editor de esos sitio web de comercio electrónico)
            independientemente de cual sea el sufijo genérico, geográfico o la
            extensión del nombre del dominio del sitio de internet del Cliente y
            el país de recepción del Contenido, de los lugares físicos de venta
            (revistas, corners) del Cliente, de las ferias, salones,
            exposiciones, lugares físicos publicitarios y cualquier otra
            manifestación pública en la que el Cliente esté presente o
            representado así como internamente a beneficio de los miembros y
            empleados del Cliente.
          </li>
        </ul>
        <p>
          La presente autorización se concede a todo el mundo y durante un plazo
          de veinte (20) años, a partir de la fecha de su aceptación del
          presente contrato.
        </p>
        <p>
          Usted declara y garantiza haber obtenido el consentimiento por escrito
          de las personas representadas en el Contenido, o de sus representantes
          legales, para la utilización de los atributos de su personalidad
          (especialmente la imagen, nombre, voz) con el objeto de que el
          Contenido pueda ser utilizado libremente, difundido, reproducido y
          explotado por Skeepers y su Cliente dentro de las condiciones
          estipuladas en las clausulas presentes. Usted se compromete a
          justificar esta autorización, sin demora, a la primera solicitud de
          Skeepers. Usted se compromete a indemnizar a Skeepers por todas las
          consecuencias que pudieran resultar de cualquier disconformidad,
          reclamación o acción emprendida por un tercero relativa a la
          utilización de los atributos de su personalidad.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Disposiciones comunes</p>
        <p>
          La cesión de sus derechos sobre el Contenido, de acuerdo con el punto
          1) y la autorización para utilizar su imagen conforme a lo estipulado
          en el punto 2) se concede para la explotación, el funcionamiento y la
          promoción institucional y publicitaria por parte de Skeepers para su
          sitio web, su plataforma y sus actividades además de para la promoción
          institucional y publicitaria de los productos, servicios y actividades
          de sus beneficiarios (especialmente los fabricantes, distribuidores,
          sitios de internet vendedores y más generalmente, sus clientes
          profesionales, etc.).
        </p>
        <p>
          De conformidad con el artículo L.122-7 del Código de propiedad
          intelectual, reconoce y acepta expresamente que la presente cesión de
          derechos y autorización de uso de su imagen se consiente con la única
          contrapartida del producto recibido. Usted renuncia a reclamar
          cualquier otra forma de contrapartida, inclusive de tipo financiero.
        </p>
        <p>
          En el caso hipotético de que en el momento de la aceptación del
          presente contrato usted fuese menor de edad (menor de 18 años), usted
          declara y garantiza a Skeepers que ha obtenido la autorización de sus
          padres o de los titulares de la patria potestad o, en su defecto, de
          sus tutores legales para aceptar el presente contrato. Usted se
          compromete a justificar esta autorización, sin demora, a la primera
          solicitud de Skeepers.
        </p>
        <p>
          En caso de contradicción entre el presente contrato y las condiciones
          generales de uso del sitio web y de la plataforma Skeepers,
          prevalecerán las estipulaciones del presente contrato.
        </p>
        <p>
          En el caso de anulación por un tribunal u otra autoridad competente de
          una de las cláusulas del presente contrato, todas las cláusulas
          restantes del presente contrato continuarán en vigor, a menos que,
          debido a la anulación de dicha cláusula, estas queden sin objeto o
          sean imposibles de ejecutar.
        </p>
        <p>El presente acuerdo se somete al derecho francés.</p>
        <p>
          Ninguna acción permisiva de Skeepers, independientemente de su
          naturaleza, alcance, duración o frecuencia, podrá ser considerada como
          constitutiva de un derecho para usted, ni ser interpretada como una
          renuncia por su parte a cualquiera de las disposiciones del presente
          contrato.
        </p>
        <p>
          Por acuerdo expreso, los correos electrónicos y los sistemas
          automáticos de registro utilizados por el sitio web y la plataforma de
          Skeepers darán fe entre las partes.
        </p>
      </div>
    </>
  )
}

export default CommunityAgreementES
